import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  base: process.env.BASE_URL,
  routes: [
    // ======================
    // Blank Layout
    // ======================    
    {
      path: '',
      component: () => import('./layout/blank/Blank.vue'),
      // ======================
      // Theme routes / pages
      // ======================
      children: [{
          path: '/',
          name: 'LandingPage',
          component: () => import('./views/pages/Index.vue')
        }, {
          path: '/login',
          name: 'Login',
          index: 1,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/Login.vue')
        }, {
          path: '/index',
          name: 'Index',
          index: 1,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/pages/Index.vue')
        }, {
          path: '/aktywacja',
          name: 'Activation',
          index: 2,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/Activation.vue')
        }, {
          path: '/email-resend',
          name: 'EmailResend',
          index: 3,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/EmailResend.vue')
        }, {
          path: '/email-verify',
          name: 'EmailVerified',
          index: 4,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/EmailVerified.vue')
        }, {
          path: '/password-resend',
          name: 'PasswordResend',
          index: 5,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/PasswordResend.vue')
        }, {
          path: '/error404',
          name: 'Error 404',
          index: 6,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/Error404.vue')
        }, {
          path: '/register',
          name: 'Register',
          index: 7,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/Register.vue')
        },
        {
          path: '/check-email',
          name: 'CheckEmail',
          index: 8,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/CheckEmail.vue')
        },
        {
          path: '/reset-link-send',
          name: 'ResetPasswordCheckEmail',
          index: 9,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/ResetPasswordCheckEmail.vue')
        },
        {
          path: '/password-reset',
          name: 'PasswordReset',
          index: 10,
          meta: {
            requiresUnauth: true,
          },
          component: () => import('./views/authentication/PasswordReset.vue')
        }, {
          path: '/connect/:presta_hash',
          name: 'PrestaConnect',
          index: 11,
          component: () => import('./views/authentication/PrestaConnect.vue')
        }
      ]
    },
    {
      // ======================
      // Full Layout
      // ======================
      path: '',
      component: () => import('./layout/full/MainContainer.vue'),
      // ======================
      // Theme routes / pages
      // ======================
      children: [{
          path: '/dashboard',
          name: 'Panel klubowicza',
          index: 1,
          meta: {
            requiresAuth: true,
          },
          i18n: "Panel klubowicza",
          component: () => import('./views/dashboards/classic-dashboard/ClassicDashboard.vue')
        },
        // Personal information
        {
          path: '/personal',
          name: 'Mój profil',
          index: 2,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              title: 'Mój profil',
              active: true
            }, ],
          },
          component: () => import('./views/pages/Personal.vue')
        },
        // Personal information
        {
          path: '/history',
          name: 'Historia',
          index: 3,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              title: 'Historia',
              active: true
            }, ],
          },
          component: () => import('./views/pages/History.vue')
        },
        // Personal information
        // {
        //     path: '/points',
        //     name: 'Punkty',
        //     index: 4,
        //     meta: {
        //         requiresAuth: true,
        //         breadcrumb: [{
        //             title: 'Punkty',
        //             active: true
        //         }, ],
        //     },
        //     component: () => import('./views/pages/Points.vue')
        // },
      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/Error404'
    }
  ]
})

import NProgress from 'nprogress';

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresUnauth = to.matched.some(record => record.meta.requiresUnauth)
  const token = sessionStorage.getItem('userToken');
  if (requiresAuth && token === null) {
    next({ path: '/login'})
  } else if (requiresUnauth && token != null) {
    next({ path: '/dashboard'})
  } else next()
})

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})
export default router
